import React, { useEffect, useState } from 'react'
import { Tabs, Group, Box, Card } from '@mantine/core'

import TransparenciaTab from '../../components/transparencia/TransparenciaTab'
import TabLicencas from '../../components/transparencia/TabLicencas'
import TabAutos from '../../components/transparencia/TabAutos'
import TabTermos from '../../components/transparencia/TabTermos'
import TabCarteiras from '../../components/transparencia/TabCarteiras'
import TabDis from '../../components/transparencia/TabDis'
import ArrowLeftIcon from '../../assets/icons/ArrowLeftIcon'
import { CustomSubtitle, CustomTitle } from './styles'

const Transparencia = () => {
    const [abaAtiva, setAbaAtiva] = useState('licencas')

    useEffect(() => {
        console.log('abaAtiva:', abaAtiva)
    }, [abaAtiva])

    const voltarPagina = () => {
        window.history.back()
    }

    return (
        <Card
            shadow="xs"
            padding={'lg'}
            radius="lg"
            style={{
                backgroundColor: '#F7F9F6',
                paddingTop: '4rem'
            }}
            mt={'-3rem'}
        >
            {/* Header */}
            <Group mb="lg" spacing="xs">
                <CustomTitle order={2}>
                    <button onClick={voltarPagina} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'unset' }}>
                        <ArrowLeftIcon size="20" /> Voltar
                    </button>
                    Portal de{' '}
                    <span style={{ fontWeight: 'bold' }}>Sistemas</span>
                </CustomTitle>
            </Group>

            <CustomSubtitle order={3} color="gray.6" mb="xl">
                Módulo de Transparência
            </CustomSubtitle>

            <>
                {/* Tabs Menu */}
                <Tabs value={abaAtiva} onChange={setAbaAtiva}>
                    <Tabs.List>
                        <TransparenciaTab value="licencas" abaAtiva={abaAtiva}>
                            Licenças/autorizações emitidas (SISLAM)
                        </TransparenciaTab>
                        <TransparenciaTab value="dis" abaAtiva={abaAtiva}>
                            Declarações de Inexigibilidade – DI (SISLAM)
                        </TransparenciaTab>
                        <TransparenciaTab value="autos" abaAtiva={abaAtiva}>
                            Autos de Infração emitidos (Fiscalização Online)
                        </TransparenciaTab>
                        <TransparenciaTab value="termos" abaAtiva={abaAtiva}>
                            Termos emitidos (Fiscalização Online)
                        </TransparenciaTab>
                        <TransparenciaTab value="carteira" abaAtiva={abaAtiva}>
                            Carteiras de Pesca emitidas (Sistema de Carteira de Pesca)
                        </TransparenciaTab>
                    </Tabs.List>

                    <Box p="md">
                        <Tabs.Panel value="licencas" pt="md">
                            {abaAtiva === 'licencas' && <TabLicencas />}
                        </Tabs.Panel>

                        <Tabs.Panel value="dis" pt="md">
                            {abaAtiva === 'dis' && <TabDis />}
                        </Tabs.Panel>

                        <Tabs.Panel value="autos" pt="md">
                            {abaAtiva === 'autos' && <TabAutos />}
                        </Tabs.Panel>

                        <Tabs.Panel value="termos" pt="md">
                            {abaAtiva === 'termos' && <TabTermos />}
                        </Tabs.Panel>

                        <Tabs.Panel value="carteira" pt="md">
                            {abaAtiva === 'carteira' && <TabCarteiras />}
                        </Tabs.Panel>
                    </Box>
                </Tabs>
            </>
        </Card>
    )
}

export default Transparencia
